/**
 * Figma spacing scale — 1x = 4px (Tailwind: `1` → 4px, `0.5` → 2px, `2` → 8px…).
 * Design System AIMS OS.
 */

export const SPACING_UNIT_PX = 4;

/** Tailwind spacing keys → px (for docs / Storybook). */
export const spacingScalePx = {
  0: 0,
  0.5: 2,
  1: 4,
  1.5: 6,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  7: 28,
  8: 32,
  12: 48,
};

/** Reusable gap / padding utilities aligned to the x-grid. */
export const spacingClass = {
  gap0_5x: 'gap-0.5',
  gap1x: 'gap-1',
  gap2x: 'gap-2',
  gap3x: 'gap-3',
  gap4x: 'gap-4',
  gapX2x: 'gap-x-2',
  gapY0_5x: 'gap-y-0.5',
  gapY1x: 'gap-y-1',
};
